import React from 'react';

export function LogoIcon({ size = 44 }) {
  const r = size * 0.25;
  return (
    <svg width={size} height={size} viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg">
      <rect width="44" height="44" rx={r} fill="#0f6e56"/>
      <rect x="9" y="30" width="6" height="8" rx="1.5" fill="white" opacity="0.35"/>
      <rect x="18" y="25" width="6" height="13" rx="1.5" fill="white" opacity="0.65"/>
      <rect x="27" y="18" width="6" height="20" rx="1.5" fill="white"/>
      <circle cx="12" cy="30" r="1.5" fill="white" opacity="0.35"/>
      <circle cx="21" cy="25" r="1.5" fill="white" opacity="0.65"/>
      <circle cx="30" cy="18" r="2" fill="white"/>
      <polyline points="12,30 21,25 30,18" fill="none" stroke="white" strokeWidth="1.2" strokeLinecap="round" opacity="0.45"/>
    </svg>
  );
}

export function LogoFull({ dark = false, size = 'md' }) {
  const sizes = { sm: { icon: 32, font: 18, sub: 9 }, md: { icon: 44, font: 24, sub: 10 }, lg: { icon: 64, font: 34, sub: 12 } };
  const s = sizes[size] || sizes.md;
  const textColor = dark ? 'white' : '#0f6e56';
  const subColor = dark ? 'rgba(255,255,255,0.5)' : '#3a8c6e';

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      <LogoIcon size={s.icon} />
      <div>
        <div style={{ fontFamily: 'Georgia, serif', fontSize: s.font, fontWeight: 700, color: textColor, letterSpacing: -0.5, lineHeight: 1.1 }}>
          Finly<span style={{ fontWeight: 400, opacity: 0.45 }}>Books</span>
        </div>
        <div style={{ fontFamily: 'Arial, sans-serif', fontSize: s.sub, color: subColor, letterSpacing: 2, marginTop: 2 }}>
          TRACK · MANAGE · GROW
        </div>
      </div>
    </div>
  );
}

export function LogoMark({ dark = false }) {
  return (
    <div style={{ textAlign: 'center' }}>
      <LogoIcon size={72} />
      <div style={{ fontFamily: 'Georgia, serif', fontSize: 28, fontWeight: 700, color: dark ? 'white' : '#0f6e56', marginTop: 10, letterSpacing: -0.5 }}>
        Finly<span style={{ fontWeight: 400, opacity: 0.45 }}>Books</span>
      </div>
      <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 10, color: dark ? 'rgba(255,255,255,0.5)' : '#3a8c6e', letterSpacing: 2.5, marginTop: 4 }}>
        TRACK · MANAGE · GROW
      </div>
    </div>
  );
}
